(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-post"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__p3BlogPostSubmitBound) return;
    window.__p3BlogPostSubmitBound = true;

    const MOBILE_BREAKPOINT = 749;
    const sidebarBySection = new WeakMap();

    const trimLeadingEmptyParagraphs = () => {
      document.querySelectorAll('.p3-blog-post__content').forEach((content) => {
        let firstNode = content.firstElementChild;

        while (firstNode && firstNode.tagName === 'P') {
          const text = firstNode.textContent.replace(/\u00A0/g, '').trim();
          const hasMedia = firstNode.querySelector('img, video, iframe, embed, object');
          const childElements = Array.from(firstNode.children);
          const hasOnlyLineBreaks = childElements.length > 0 && childElements.every((child) => child.tagName === 'BR');

          if (text !== '' || hasMedia || (!hasOnlyLineBreaks && childElements.length > 0)) {
            break;
          }

          const nextNode = firstNode.nextElementSibling;
          firstNode.remove();
          firstNode = nextNode;
        }
      });
    };

    const getMobileYoutubeSrc = (rawSrc) => {
      let parsedUrl;

      try {
        parsedUrl = new URL(rawSrc, window.location.origin);
      } catch (error) {
        return null;
      }

      const host = parsedUrl.hostname.toLowerCase();
      const isYoutubeHost = /(youtube\.com|youtube-nocookie\.com|youtu\.be)$/.test(host);
      if (!isYoutubeHost) return null;

      let videoId = '';
      if (host.endsWith('youtu.be')) {
        videoId = parsedUrl.pathname.replace(/^\/+/, '').split('/')[0];
      } else if (parsedUrl.pathname.includes('/embed/')) {
        videoId = parsedUrl.pathname.split('/embed/')[1].split('/')[0];
      } else {
        videoId = parsedUrl.searchParams.get('v') || '';
      }

      const embedUrl = videoId
        ? new URL(`https://www.youtube-nocookie.com/embed/${videoId}`)
        : new URL(parsedUrl.toString());

      const startParam = parsedUrl.searchParams.get('start') || parsedUrl.searchParams.get('t');
      const listParam = parsedUrl.searchParams.get('list');

      if (startParam) {
        const normalizedStart = String(startParam).replace(/s$/i, '');
        embedUrl.searchParams.set('start', normalizedStart);
      }
      if (listParam) {
        embedUrl.searchParams.set('list', listParam);
      }

      embedUrl.searchParams.set('playsinline', '1');
      embedUrl.searchParams.set('modestbranding', '1');
      embedUrl.searchParams.set('rel', '0');
      embedUrl.searchParams.set('iv_load_policy', '3');
      embedUrl.searchParams.set('controls', '0');
      embedUrl.searchParams.set('fs', '0');
      embedUrl.searchParams.set('disablekb', '1');
      embedUrl.searchParams.set('showinfo', '0');

      return embedUrl.toString();
    };

    const updateMobileYoutubeEmbeds = () => {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      document.querySelectorAll('.p3-blog-post iframe').forEach((iframe) => {
        const currentSrc = iframe.getAttribute('src');
        if (!currentSrc) return;

        if (!iframe.dataset.p3OriginalSrc) {
          iframe.dataset.p3OriginalSrc = currentSrc;
        }

        const originalSrc = iframe.dataset.p3OriginalSrc;
        if (!/(youtube\.com|youtube-nocookie\.com|youtu\.be)/i.test(originalSrc)) return;

        if (!isMobile) {
          if (iframe.dataset.p3MobileSrc && currentSrc === iframe.dataset.p3MobileSrc) {
            iframe.setAttribute('src', originalSrc);
          }
          return;
        }

        const mobileSrc = getMobileYoutubeSrc(originalSrc);
        if (!mobileSrc) return;

        iframe.dataset.p3MobileSrc = mobileSrc;
        if (currentSrc !== mobileSrc) {
          iframe.setAttribute('src', mobileSrc);
        }
      });
    };

    const relocateMobileSidebar = () => {
      document.querySelectorAll('.p3-blog-post').forEach((blogSection) => {
        const anchor = blogSection.querySelector('.p3-blog-post__sidebar-anchor');
        if (!anchor) return;

        let sidebar = blogSection.querySelector('.p3-blog-post__sidebar') || sidebarBySection.get(blogSection);
        if (!sidebar) return;

        sidebarBySection.set(blogSection, sidebar);

        const sectionWrapper = blogSection.closest('.shopify-section');
        let nextSection = sectionWrapper ? sectionWrapper.nextElementSibling : null;
        let insightsWrapper = null;

        while (nextSection) {
          if (nextSection.querySelector('.p3-insights-grid')) {
            insightsWrapper = nextSection;
            break;
          }
          nextSection = nextSection.nextElementSibling;
        }

        const shouldMove = window.innerWidth <= MOBILE_BREAKPOINT && Boolean(insightsWrapper);

        if (shouldMove) {
          if (sidebar.parentElement !== insightsWrapper.parentElement || sidebar.previousElementSibling !== insightsWrapper) {
            insightsWrapper.insertAdjacentElement('afterend', sidebar);
          }
          sidebar.classList.add('p3-blog-post__sidebar--moved');
        } else {
          if (anchor.parentElement && anchor.nextElementSibling !== sidebar) {
            anchor.insertAdjacentElement('afterend', sidebar);
          }
          sidebar.classList.remove('p3-blog-post__sidebar--moved');
        }
      });
    };

    document.addEventListener('click', (event) => {
      const submitTrigger = event.target.closest('.p3-blog-post__btn');
      if (!submitTrigger) return;

      const parentForm = submitTrigger.closest('form');
      if (!parentForm) return;

      event.preventDefault();

      if (typeof parentForm.requestSubmit === 'function') {
        parentForm.requestSubmit();
      } else {
        parentForm.submit();
      }
    });

    const populateMobileVideoCardFromIframe = () => {
      if (window.innerWidth > MOBILE_BREAKPOINT) return;
      document.querySelectorAll('.p3-blog-post__mobile-video-card[data-mobile-video-card]').forEach((card) => {
        const placeholder = card.querySelector('[data-mobile-video-card-thumb-placeholder]');
        if (!placeholder) return;
        const section = card.closest('.p3-blog-post');
        if (!section) return;
        const content = section.querySelector('.p3-blog-post__content');
        if (!content) return;
        const iframe = content.querySelector('iframe[src*="youtube"], iframe[src*="youtu.be"]');
        if (!iframe || !iframe.src) return;
        let videoId = '';
        try {
          const u = new URL(iframe.src);
          if (u.hostname.includes('youtu.be')) {
            videoId = u.pathname.replace(/^\/+/, '').split('/')[0];
          } else {
            videoId = u.searchParams.get('v') || (u.pathname.includes('/embed/') ? u.pathname.split('/embed/')[1].split('/')[0] : '');
          }
        } catch (e) {
          return;
        }
        if (!videoId) return;
        const watchUrl = 'https://www.youtube.com/watch?v=' + videoId;
        const thumbUrl = 'https://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg';
        const link = card.querySelector('[data-mobile-video-card-link]');
        if (link && link.getAttribute('href') === '#') {
          link.setAttribute('href', watchUrl);
        }
        const img = document.createElement('img');
        img.className = 'p3-blog-post__mobile-video-card-thumb';
        img.src = thumbUrl;
        img.alt = '';
        img.width = 335;
        img.height = 188;
        img.loading = 'lazy';
        img.dataset.mobileVideoCardThumb = '';
        placeholder.parentNode.replaceChild(img, placeholder);
      });
    };

    trimLeadingEmptyParagraphs();
    updateMobileYoutubeEmbeds();
    relocateMobileSidebar();
    populateMobileVideoCardFromIframe();
    window.addEventListener('resize', () => {
      updateMobileYoutubeEmbeds();
      relocateMobileSidebar();
    });
    window.addEventListener('orientationchange', () => {
      updateMobileYoutubeEmbeds();
      relocateMobileSidebar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-about-hero"] && !Shopify.designMode) return;
  try {
    
  class AboutHeroMediaController {
    constructor(button) {
      this.button = button;
      this.wrapper = button.closest('.p3-about-hero__wrapper');
      this.playIcon = button.querySelector('.p3-about-hero__play-icon');
      this.pauseIcon = button.querySelector('.p3-about-hero__pause-icon');
      this.isPlaying = true;
      
      // Check for video
      this.videoId = button.dataset.videoControl;
      this.video = this.videoId ? document.getElementById(this.videoId) : null;
      
      // Check for gif
      this.gif = this.wrapper.querySelector('.p3-about-hero__gif');
      this.canvas = this.wrapper.querySelector('.p3-about-hero__canvas');
      
      if (this.video || this.gif) {
        this.init();
      }
    }

    init() {
      this.button.addEventListener('click', () => this.toggle());
      
      // Initialize icons based on current state
      if (this.video || this.gif) {
        this.pauseIcon.style.display = 'block';
        this.playIcon.style.display = 'none';
      }
    }

    toggle() {
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }

    play() {
      if (this.video) {
        this.video.play();
      } else if (this.gif && this.canvas) {
        // Show gif, hide canvas
        this.gif.style.display = 'block';
        this.canvas.style.display = 'none';
      }
      
      this.isPlaying = true;
      this.playIcon.style.display = 'none';
      this.pauseIcon.style.display = 'block';
    }

    pause() {
      if (this.video) {
        this.video.pause();
      } else if (this.gif && this.canvas) {
        // Capture current frame to canvas
        const ctx = this.canvas.getContext('2d');
        this.canvas.width = this.gif.naturalWidth || this.gif.width;
        this.canvas.height = this.gif.naturalHeight || this.gif.height;
        ctx.drawImage(this.gif, 0, 0);
        
        // Hide gif, show canvas
        this.gif.style.display = 'none';
        this.canvas.style.display = 'block';
      }
      
      this.isPlaying = false;
      this.playIcon.style.display = 'block';
      this.pauseIcon.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const mediaButtons = document.querySelectorAll('.p3-about-hero__play-pause');
    mediaButtons.forEach(button => new AboutHeroMediaController(button));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-book-strategy-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.p3-strategy-cta__modal');
    if (!modal) return;

    var iframe = modal.querySelector('.p3-hero__modal-iframe');

    function openModal(url) {
      iframe.src = url;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      iframe.src = '';
      document.body.style.overflow = '';
    }

    var btn = document.querySelector('.p3-book-strategy-cta__btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(this.href);
      });
    }

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-core-services-scroll"] && !Shopify.designMode) return;
  try {
    
  const scrollContainer = document.querySelector('.p3-core-services__right');
  
  if (scrollContainer) {
    function updateScrollState() {
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const scrollBottom = scrollHeight - scrollTop - clientHeight;
      
      if (scrollTop <= 5 && scrollBottom <= 5) {
        scrollContainer.removeAttribute('data-scroll');
      } else if (scrollTop <= 5) {
        scrollContainer.setAttribute('data-scroll', 'top');
      } else if (scrollBottom <= 5) {
        scrollContainer.setAttribute('data-scroll', 'bottom');
      } else {
        scrollContainer.setAttribute('data-scroll', 'middle');
      }
    }
    
    updateScrollState();
    scrollContainer.addEventListener('scroll', updateScrollState);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-cta-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.p3-cta-banner__modal');
    if (!modal) return;

    var iframe = modal.querySelector('.p3-hero__modal-iframe');

    function openModal(url) {
      iframe.src = url;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      iframe.src = '';
      document.body.style.overflow = '';
    }

    var btn = document.querySelector('.p3-cta-banner__btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(this.href);
      });
    }

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.querySelector('.p3-header__hamburger');
    const closeBtn = document.querySelector('.p3-header__close');
    const mobileMenu = document.querySelector('.p3-header__mobile-menu');

    if (hamburger) {
      hamburger.addEventListener('click', function() {
        mobileMenu.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close mobile menu when clicking outside
    if (mobileMenu) {
      mobileMenu.addEventListener('click', function(e) {
        if (e.target === mobileMenu) {
          mobileMenu.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }

    // Handle dropdown clicks on desktop
    const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');
    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const parent = this.closest('.p3-header__menu-item--parent');
        const isActive = parent.classList.contains('active');

        // Close all other dropdowns
        document.querySelectorAll('.p3-header__menu-item--parent').forEach(p => {
          p.classList.remove('active');
        });

        // Toggle current dropdown
        if (!isActive) {
          parent.classList.add('active');
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.p3-header__menu-item--parent')) {
        document.querySelectorAll('.p3-header__menu-item--parent').forEach(parent => {
          parent.classList.remove('active');
        });
      }
    });

    // Book a Call — open hero modal if present on the page
    const heroModal = document.querySelector('.p3-hero__modal');
    if (heroModal) {
      const iframe = heroModal.querySelector('.p3-hero__modal-iframe');

      function openHeroModal(url) {
        iframe.src = url;
        heroModal.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      ['.p3-header__cta-button--rocket', '.p3-header__cta-button--mobile'].forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            openHeroModal(this.href);
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-insights-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      const grid = section.querySelector('.p3-insights-grid__grid');
      const progress = section.querySelector('[data-insights-progress]');
      const thumb = section.querySelector('[data-insights-progress-thumb]');
      if (!grid || !progress || !thumb) return;

      let rafId = null;

      const update = () => {
        rafId = null;

        const maxScroll = grid.scrollWidth - grid.clientWidth;
        if (maxScroll <= 1) {
          progress.style.display = 'none';
          return;
        }

        progress.style.removeProperty('display');

        const trackWidth = progress.clientWidth;
        const thumbWidth = thumb.offsetWidth;
        const maxTranslate = Math.max(0, trackWidth - thumbWidth);

        const ratio = Math.min(1, Math.max(0, grid.scrollLeft / maxScroll));
        thumb.style.transform = `translateX(${ratio * maxTranslate}px)`;
      };

      const scheduleUpdate = () => {
        if (rafId != null) return;
        rafId = requestAnimationFrame(update);
      };

      grid.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      window.addEventListener('load', scheduleUpdate);

      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 0);
    };

    const initAll = () => {
      document.querySelectorAll('[data-p3-insights-grid]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-pos-trust-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initParallax(sectionEl) {
      var container = sectionEl.querySelector('[data-parallax-container]');
      var items = sectionEl.querySelectorAll('[data-parallax-items] .p3-pos-trust__item');
      if (!container || !items.length) return;

      var ticking = false;
      var lastScrollY = 0;

      /* Alternate items shift in opposite Y directions */
      function applyParallax() {
        var rect = container.getBoundingClientRect();
        var viewH = window.innerHeight;

        /* Progress: 0 when top of container enters viewport bottom, 1 when bottom leaves top */
        var progress = 1 - (rect.bottom / (viewH + rect.height));
        progress = Math.max(-0.5, Math.min(1.5, progress));

        var strength = 30; /* px at full travel */

        items.forEach(function (item, i) {
          /* Even-index items move upward, odd move downward */
          var direction = (i % 2 === 0) ? -1 : 1;
          var offset = direction * progress * strength;
          item.style.transform = 'translateY(' + offset + 'px)';
        });

        ticking = false;
      }

      function onScroll() {
        lastScrollY = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(applyParallax);
          ticking = true;
        }
      }

      /* Only run parallax on non-reduced-motion desktops */
      var mediaQuery = window.matchMedia('(min-width: 750px) and (prefers-reduced-motion: no-preference)');

      function handleMedia(mq) {
        if (mq.matches) {
          window.addEventListener('scroll', onScroll, { passive: true });
          applyParallax();
        } else {
          window.removeEventListener('scroll', onScroll);
          items.forEach(function (item) { item.style.transform = ''; });
        }
      }

      mediaQuery.addEventListener('change', handleMedia);
      handleMedia(mediaQuery);
    }

    document.querySelectorAll('#p3-pos-trust-{{ section.id }}').forEach(initParallax);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-video-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideoController {
    constructor(button) {
      this.button = button;
      this.videoId = button.dataset.videoControl;
      this.video = document.getElementById(this.videoId);
      this.playIcon = button.querySelector('.p3-hero__play-icon');
      this.pauseIcon = button.querySelector('.p3-hero__pause-icon');

      if (this.video) {
        this.init();
      }
    }

    init() {
      this.video.play().catch(() => {});
      this.button.addEventListener('click', () => this.toggle());
      this.video.addEventListener('play', () => this.syncState());
      this.video.addEventListener('pause', () => this.syncState());
    }

    syncState() {
      const isPlaying = !this.video.paused;
      this.playIcon.style.display = isPlaying ? 'none' : 'block';
      this.pauseIcon.style.display = isPlaying ? 'block' : 'none';
    }

    toggle() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const videoButtons = document.querySelectorAll('[data-video-control]');
    videoButtons.forEach(button => new HeroVideoController(button));

    // Book a Call modal
    const modal = document.querySelector('.p3-hero__modal');

    if (modal) {
      const iframe = modal.querySelector('.p3-hero__modal-iframe');

      function openModal(url) {
        iframe.src = url;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.hidden = true;
        iframe.src = '';
        document.body.style.overflow = '';
      }

      // Main CTA button
      const mainCta = document.querySelector('.p3-hero__main-cta');
      if (mainCta) {
        mainCta.addEventListener('click', function (e) {
          e.preventDefault();
          openModal(this.href);
        });
      }

      // Secondary glass CTA buttons — open in modal if linking to Calendly
      document.querySelectorAll('.p3-hero__glass-button').forEach(function (btn) {
        if (btn.href && btn.href.includes('calendly')) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            openModal(this.href);
          });
        }
      });

      modal.querySelectorAll('[data-modal-close]').forEach(el => {
        el.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
